<template lang="html">
  <section class="section">
    <HeaderSection
      :title="name || $t('components.progressGroupDirector.director')">
      <a
        v-if="!isDashboard"
        :href="vcloud_url"
        target="_blank"
        class="is-right-aligned block">
          <button class="button is-gamma is-xsmall mb--30">{{ $t('components.progressGroupDirector.manage') }}</button>
      </a>
    </HeaderSection>

    <div v-if="generatedPools.length == 0" class="is-center-aligned pa-5 ">{{ $t('components.progressGroupDirector.empty') }}</div>
    <template
    v-for="(pool, index) in generatedPools"
    class="director-pool">
    <div v-if="pool" class="section-content has-no-border">
        <p>{{ pool.name | uppercase }}</p>
        <div class="flex items-center is-justified-end">
          <button
            v-if="editPoolPermission && displayEdit && !pool.is_global"
            v-on:click.prevent="openEditPool(pool)"
            class="button is-gamma is-xsmall mr-30">
              {{ $t('components.progressGroupDirector.edit') }}
          </button>
          <Label
            v-if="pool.count_power_on"
            :total="pool.count_vm"
            :qty="pool.count_power_on"
            :tooltipText="c('director')"
            :label="$t('components.progressGroupDirector.form.running')"/>
        </div>
      </div>
      <div class="section-content is-justify-start">
        <ProgressStandalone
          :value="pool.cpu_used"
          :total="pool.vcpu"
          :label="$t('components.progressGroupDirector.form.cpu')"
          :unit="$t('components.progressGroupDirector.form.ghz')"
          color="delta"/>
        <ProgressStandalone
          :value="pool.memory_used"
          :total="pool.vram"
          :label="$t('components.progressGroupDirector.form.memory')"
          :unit="$t('components.progressGroupDirector.form.gb')"
          color="gamma"/>
        <ProgressStandalone
          :value="pool.use_storage"
          :total="pool.max_storage"
          :label="$t('components.progressGroupDirector.form.storage')"
          :unit="$t('components.progressGroupDirector.form.gb')"
          color="alpha"/>
      </div>
    </template>
  </section>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import { eventHubMixin } from '@/mixins/event';

import HeaderSection from '@/components/HeaderSection.vue';
import Label from '@/components/Label.vue';
import ProgressStandalone from '@/components/ProgressStandalone.vue';


export default {
  name: 'ProgressGroupDirector',
  mixins: [eventHubMixin],
  components: {
    HeaderSection,
    Label,
    ProgressStandalone,
  },
  filters: {
    uppercase(value) {  
      if (value) {
        return value.toUpperCase();
      }
    },
  },
  props: {
    name: {
      type: String,
      required: false
    },
    host: {
      type: String,
      required: false
    },
    pools: {
      type: Array,
      required: true,
    },
    displayEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDashboard: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlyGlobal: {
      type: Boolean,
      required: false,
      default: false,
    },

  },
  mounted() {

  },
  data() {
    return {
      globalPoolSettings: {
        count_power_on: 0,
        count_vm: 0,
        vcpu: 0,
        cpu_used: 0,
        vram: 0,
        memory_used: 0,
        max_storage: 0,
        use_storage: 0,
        is_global: true
      },
    };
  },
  methods: {
    openEditPool(pool) {
      this.emitOpenModal('add-edit-pool', pool);
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      contents: 'contents/Contents',
    }),
    vcloud_url() {
      if (this.user) {
        return `${this.host}/tenant/${this.user.company_obj.name}`;
      }
    },
    globalPool() {
      const globalSettings = {
        name: this.$t('components.progressGroupDirector.stats'),
        tooltipText: 'Mollit dolor exercitation aliquip velit ad enim commodo veniam nisi.',
      };

      // generate global stats based on other pools data
      return this.pools.reduce((prev, curr) => {
        Object.keys(curr).forEach((key) => {
          if (this.globalPoolSettings.hasOwnProperty(key)) {
            prev[key] = ((!prev[key]) ? 0 : prev[key]) + curr[key];
          }
        });
        return prev;
      }, globalSettings);
    },

    generatedPools() {
      // add title depending on index and add global stats to pools to iterate through array
      const { pools } = this;
      if (pools.length > 1) {
        if (this.onlyGlobal) {
          return [this.globalPool];
        }
        this.globalPool.is_global = true;
        pools.unshift(this.globalPool);
      }
      return pools;
    },

    editPoolPermission() {
      if ((this.user.is_admin || this.user.roles_obj.some(role => role.opening_pool_update_ticket))) {
        return true
      }
      return false
    },
  },
};
</script>

<style scoped lang="scss">
</style>
